export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-accent-400/30 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-12 -left-8 h-44 w-44 rounded-full bg-background-50/10 blur-2xl" />

          <div className="relative mx-auto max-w-2xl">
            <p className="text-xs font-medium tracking-widest text-background-50/70">现在就试试</p>
            <h2 className="mt-3 font-heading text-3xl leading-snug text-background-50 md:text-4xl">
              一条链接，把网页素材扒进口袋
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-50/80 md:text-base">
              文字、图片、视频、链接与源码，随取随用。不必登录、不必等待，打开浏览器即可开始。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#demo"
                className="inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm whitespace-nowrap font-medium text-primary-700 transition-colors hover:bg-background-100"
              >
                立即开始体验
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
              <a
                href="#scenes"
                className="inline-flex items-center gap-2 rounded-full border border-background-50/30 px-7 py-3 text-sm whitespace-nowrap text-background-50 transition-colors hover:bg-background-50/10"
              >
                看看适用场景
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}